import { defineMessages } from "react-intl";

export const messages = defineMessages({
    dashboardButtonLabel: {
        id: "fastshift.dashboard.dashboard-button-label",
        defaultMessage: "Dashboard",
        description: "Label for the dashboard button"
    },
    fastshiftProductHomeTitle: {
        id: "fastshift.dashboard.product-home-title",
        defaultMessage: "FastShift",
        description: "Title for the FastShift product home"
    }
});
